export function headerScroll() {
    $(".header .btn-scroll").on("click", function () {
        let scroll = $(".header").next().offset().top;
        $("html, body").animate({
            scrollTop: scroll
        }, 700);
        return false;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerScroll.js